const DiscountSixthCase = {
    name: 'DiscountSixthCase',
    functional: true,
    render: h => (
        <fragment>
            <div class="discount-cases-description">มีได้ทั้งหมด 6 กรณี</div>
            <div class="possible-cases-container">
                <div class="possible-cases-item">
                    <div class="person-case">
                        <i class="fas fa-user parent-icon" />
                        <i class="fas fa-user parent-icon" />2 บิดา+มารดา
                    </div>
                    <div class="person-case">
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />4 เด็กโต
                    </div>
                </div>

                <div class="possible-cases-item">
                    <div class="person-case">
                        <i class="fas fa-user parent-icon" />
                        <i class="fas fa-user parent-icon" />2 บิดา+มารดา
                    </div>
                    <div class="person-case">
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />3 เด็กโต
                    </div>
                    <div class="person-case">
                        <i class="fas fa-baby baby-icon" />1 เด็กเล็ก
                    </div>
                </div>

                <div class="possible-cases-item">
                    <div class="person-case">
                        <i class="fas fa-user parent-icon" />
                        <i class="fas fa-user parent-icon" />2 บิดา+มารดา
                    </div>
                    <div class="person-case">
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />2 เด็กโต
                    </div>
                    <div class="person-case">
                        <i class="fas fa-baby baby-icon" />
                        <i class="fas fa-baby baby-icon" />2 เด็กเล็ก
                    </div>
                </div>

                <div class="possible-cases-item">
                    <div class="person-case">
                        <i class="fas fa-user parent-icon" />1 บิดา/มารดา
                    </div>
                    <div class="person-case">
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />5 เด็กโต
                    </div>
                </div>

                <div class="possible-cases-item">
                    <div class="person-case">
                        <i class="fas fa-user parent-icon" />1 บิดา/มารดา
                    </div>
                    <div class="person-case">
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />4 เด็กโต
                    </div>
                    <div class="person-case">
                        <i class="fas fa-baby baby-icon" />1 เด็กเล็ก
                    </div>
                </div>

                <div class="possible-cases-item">
                    <div class="person-case">
                        <i class="fas fa-user parent-icon" />1 บิดา/มารดา
                    </div>
                    <div class="person-case">
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />
                        <i class="fas fa-child adult-icon" />3 เด็กโต
                    </div>
                    <div class="person-case">
                        <i class="fas fa-baby baby-icon" />
                        <i class="fas fa-baby baby-icon" />2 เด็กเล็ก
                    </div>
                </div>
            </div>
        </fragment>
    ),
}

export default DiscountSixthCase
